function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11 24.7827C11 27.5441 13.2386 29.7827 16 29.7827H27.7826C28.8872 29.7827 29.7826 28.8873 29.7826 27.7827V16.0001C29.7826 13.2387 27.544 11.0001 24.7826 11.0001H16C13.2386 11.0001 11 13.2387 11 16.0001V24.7827Z",
  stroke: "#CDCDCD",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M19.2174 33C19.2174 35.7614 21.456 38 24.2174 38H33C35.7614 38 38 35.7614 38 33V24.2174C38 21.456 35.7614 19.2174 33 19.2174H21.2174C20.1128 19.2174 19.2174 20.1128 19.2174 21.2174V33Z",
  stroke: "#CDCDCD",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
});

var SvgTopCombinations = function SvgTopCombinations(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTopCombinations, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/top-combinations.91083657.svg";
export { ForwardRef as ReactComponent };